var _require = require('styled-components'),
    useTheme = _require.useTheme;

var _require2 = require('../hooks/use-breakpoint'),
    createUseBreakpoint = _require2.createUseBreakpoint;

exports.useBreakpoint = createUseBreakpoint({
  theme: useTheme
});